
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
  import { scrollToElement } from '../utils/helpers'

@Component
  export default class TourOverlay extends Vue {
  @Prop({ type: Boolean, default: false }) active!: boolean;
  @Prop({ type: String, default: '' }) targetSelector!: string;
  @Prop({ type: Number, default: 0.5 }) opacity!: number;
  @Prop({ type: Number, default: 10 }) padding!: number;
  @Prop({ type: Number, default: 4 }) borderRadius!: number;
  @Prop({ type: Boolean, default: true }) scrollIntoView!: boolean;

  // Elemento objetivo calculado
  targetElement: HTMLElement | null = null;

  // Estilos para el resaltado
  highlightStyle = {
    top: '0px',
    left: '0px',
    width: '0px',
    height: '0px',
    borderRadius: '4px',
  };

  @Watch('targetSelector')
  @Watch('active')
  updateTargetElement () {
    if (this.active && this.targetSelector) {
      setTimeout(() => {
        this.targetElement = document.querySelector(this.targetSelector)

        if (this.targetElement) {
          this.updateHighlightPosition()

          if (this.scrollIntoView) {
            scrollToElement(this.targetElement)
          }
        }
      }, 100)
    } else {
      this.targetElement = null
    }
  }

  @Watch('padding')
  @Watch('borderRadius')
  updateHighlightStyles () {
    if (this.targetElement) {
      this.updateHighlightPosition()
    }
  }

  mounted () {
    this.updateTargetElement()
    window.addEventListener('resize', this.updateHighlightPosition)
    window.addEventListener('scroll', this.updateHighlightPosition)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.updateHighlightPosition)
    window.removeEventListener('scroll', this.updateHighlightPosition)
  }

  /**
   * Actualiza la posición del resaltado según la posición del elemento
   */
  updateHighlightPosition () {
    if (!this.targetElement) return

    const rect = this.targetElement.getBoundingClientRect()

    this.highlightStyle = {
      top: `${rect.top - this.padding + window.scrollY}px`,
      left: `${rect.left - this.padding + window.scrollX}px`,
      width: `${rect.width + (this.padding * 2)}px`,
      height: `${rect.height + (this.padding * 2)}px`,
      borderRadius: `${this.borderRadius}px`,
    }
  }
  }
